import { TourRoute } from "@/modules/tours/routes/tour.route.tsx";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/tours/$tourId")({
	component: TourRoute,
});
